<template>
  <div class="ms-form">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid">
        <CustomInput
            label="Название"
            type="text"
            :required="true"
            :value="this.formData.activity_name"
            @change_input="(value) => onChange('activity_name', value)"
        />
        <CustomInput
            label="Код"
            :required="true"
            :value="this.formData.activity_code"
            @change_input="(value) => onChange('activity_code', value)"
        />
        <CustomSelect
            :options="this.activityTypes"
            label="Тип действия"
            :required="true"
            optionValueKey="activity_type_id"
            optionLabelKey="type_name"
            :value="this.formData.activity_type_id || ''"
            @change="(value) => onChange('activity_type_id', value)"
        />
        <div>
          <CustomInput
              label="Функция (func_name)"
              type="text"
              placeholder="напр. rem_logic.client_request_status_change"
              :value="this.formData.func_name"
              @change_input="(value) => onChange('func_name', value)"
          />
          <div class="fieldHint">
            Имя SQL-функции, которую выполняет действие. Оставьте пустым для действий типа «обновление поля таблицы».
          </div>
        </div>
        <JsonEditor
            class="ms-form-wide"
            label="Параметры (json)"
            :hint="paramJsonHint"
            :rows="6"
            :value="this.formData.param_json"
            @change_input="(value) => onChange('param_json', value)"
        />
        <CustomInput
            class="ms-form-wide"
            label="Описание"
            type="textarea"
            rows="2"
            :value="this.formData.description"
            @change_input="(value) => onChange('description', value)"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import JsonEditor from "@/components/form/JsonEditor";
import {getActivityTypes} from "@/views/handbook/gradeTimelineActions/services";

export default {
  name: "add-grade-action",
  components: {CustomSelect, CustomInput, CustomModalFooter, JsonEditor},
  props: ['data'],
  data() {
    return {
      loading: false,
      activityTypes: [],
      paramJsonHint:
        'Аргументы функции и доп. настройки действия (без func_name — он задаётся отдельным полем).<br>' +
        '<b>param_cnt</b> — число аргументов, <b>param_1…param_N</b> — имена аргументов по порядку.<br>' +
        'Имена client_request_id / remont_id / crm_deal_id подставляются из контекста ремонта; ' +
        'остальные значения задаются на уровне привязки действия к шагу (param_N_value).<br>' +
        'Для действий типа «обновление поля таблицы»: <b>table_name</b>, <b>field_name</b>, <b>key_field_name</b>.',
      formData: {
        activity_name: this.data?.body?.activity_name || '',
        activity_type_id: this.data?.body?.activity_type_id || '',
        param_json: '',
        func_name: '',
        activity_code: this.data?.body?.activity_code || '',
        description: this.data?.body?.description || '',
      }
    }
  },
  methods: {
    parseJson(val) {
      if (!val) return null
      if (typeof val === 'string') {
        try { return JSON.parse(val) } catch (e) { return null }
      }
      return val
    },
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      const obj = this.parseJson(this.formData.param_json) || {}
      const fn = (this.formData.func_name || '').trim()
      if (fn) {
        obj.func_name = fn
      } else {
        delete obj.func_name
      }
      const payload = {
        activity_name: this.formData.activity_name,
        activity_code: this.formData.activity_code,
        activity_type_id: this.formData.activity_type_id,
        param_json: JSON.stringify(obj),
        description: this.formData.description,
      }
      this.loading = true
      await this.data?.onSubmit(payload)
      this.loading = false
    },
    async fetchActivityTypes() {
      const res = await getActivityTypes()
      this.activityTypes = res || []
    },
    initParamJson() {
      const parsed = this.parseJson(this.data?.body?.param_json)
      if (parsed && typeof parsed === 'object') {
        this.formData.func_name = parsed.func_name || ''
        const rest = { ...parsed }
        delete rest.func_name
        this.formData.param_json = Object.keys(rest).length
          ? JSON.stringify(rest, null, 2)
          : ''
      }
    },
  },
  created() {
    this.initParamJson()
  },
  mounted() {
    this.fetchActivityTypes()
  }
}
</script>

<style scoped lang="scss">
.fieldHint {
  margin-top: 6px;
  color: var(--ms-muted);
  font-size: 11px;
  font-style: italic;
}
</style>
